import { CompaniesIconsStick } from './CompaniesIconsStick'

export default CompaniesIconsStick
